import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getFetch } from '@sift/resift/redux/FetchUtils';
import Fetch from '@sift/resift/models/Fetch';

import { fetchSource } from 'store/sources';
import { fetchDirectory } from 'store/directories';
import { Status } from '@sift/resift/models/Status/Status';

const sourceIdSelector = () => {
  // TODO (Jules): Find a better way to get the SourceId from the url.
  const paths = document.location.pathname.split('/');
  return paths[5];
};

const directoryIdSelector = () => {
  // TODO (Jules): Find a better way to get the DirectoryId from the url.
  const paths = document.location.pathname.split('/');
  return paths[3];
};

const sourcesSelector = (state, props) => state.sources;
const directoriesStateSelector = (state, props) => state.directories;

const getSourceFetch = createSelector([sourceIdSelector, sourcesSelector], (id, state) => {
  const fetch = getFetch(id, state);
  return fetch.id() ? getFetch(id, state) : new Fetch(id, [id]);
});
const getDirectoryFetch = createSelector(
  [directoryIdSelector, directoriesStateSelector],
  (id, state) => {
    const fetch = getFetch(id, state);
    return fetch.id() ? getFetch(id, state) : new Fetch(id, [id]);
  },
);

const getStatus = createSelector(
  [getSourceFetch, getDirectoryFetch],
  (sourceFetch, directoryFetch) => {
    return new Status(sourceFetch.status.value | directoryFetch.status.value);
  },
);

const mapDispatchToProps = {
  fetchSource,
  fetchDirectory,
};

const mapStateToProps = (state, ownProps) => {
  const sourceFetch = getSourceFetch(state, ownProps);
  const directoryFetch = getDirectoryFetch(state, ownProps);
  const status = getStatus(state, ownProps);

  return {
    source: sourceFetch.object(),
    sourceId: sourceFetch.id(),
    directory: directoryFetch.object(),
    directoryId: directoryFetch.id(),
    sourceStatus: sourceFetch.status,
    directoryStatus: directoryFetch.status,
    status, // TODO (Jules): status might be overridden by other props in later connector functions. Need to find a better way around this.
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const fetchSource = () => {
    dispatchProps.fetchSource(stateProps.sourceId);
  };

  const fetchDirectory = () => {
    dispatchProps.fetchDirectory(stateProps.directoryId);
  };

  return {
    ...ownProps,
    ...stateProps,
    fetchSource,
    fetchDirectory,
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps, mergeProps), Component => {
  return function container(props) {
    return <Component {...props} />;
  };
});
